import { render, staticRenderFns } from "./LayoutProvider.vue?vue&type=template&id=cc6357d4&scoped=true&"
import script from "./LayoutProvider.vue?vue&type=script&lang=ts&"
export * from "./LayoutProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6357d4",
  null
  
)

export default component.exports